import { makeVar } from '@apollo/client';

import { ICheckout } from './types';

export const initialCheckoutValue = {
	travelPlans: []
};
export const checkoutVar = makeVar<ICheckout>(initialCheckoutValue);
